(function () {
  var flkty = null;

  function readItems(edition, variantId) {
    var items = [];
    document.querySelectorAll(
      '.pdp-edition-media-item[data-edition="' + edition + '"][data-role="variant"][data-variant-id="' + variantId + '"]'
    ).forEach(function (el) {
      try { items.push(JSON.parse(el.textContent)); } catch (e) {}
    });
    document.querySelectorAll(
      '.pdp-edition-media-item[data-edition="' + edition + '"][data-role="shared"]'
    ).forEach(function (el) {
      try { items.push(JSON.parse(el.textContent)); } catch (e) {}
    });
    return items;
  }

  function escapeAttr(value) {
    return String(value || '').replace(/"/g, '&quot;');
  }

  function slideMarkup(item) {
    if (item.type === 'video') {
      var sources = (item.sources || []).map(function (s) {
        return '<source src="' + escapeAttr(s.src) + '" type="' + escapeAttr(s.type) + '">';
      }).join('');
      return '<div class="product-edition-gallery__slide"><video controls playsinline' +
        (item.poster ? ' poster="' + escapeAttr(item.poster) + '"' : '') + '>' + sources + '</video></div>';
    }
    return '<div class="product-edition-gallery__slide"><img src="' + escapeAttr(item.src) +
      '" alt="' + escapeAttr(item.alt) + '"></div>';
  }

  function thumbMarkup(item) {
    var src = item.type === 'video' ? item.poster : item.src;
    return '<img src="' + escapeAttr(src) + '" alt="">';
  }

  function enableDragScroll(el) {
    if (el.dataset.dragScrollBound) return;
    el.dataset.dragScrollBound = 'true';

    var DRAG_THRESHOLD = 5; // px of movement before a press counts as a drag, not a click
    var isDown = false;
    var hasDragged = false;
    var startX = 0;
    var startScrollLeft = 0;

    el.addEventListener('mousedown', function (e) {
      isDown = true;
      hasDragged = false;
      startX = e.pageX;
      startScrollLeft = el.scrollLeft;
    });
    window.addEventListener('mouseup', function () {
      isDown = false;
      el.classList.remove('is-dragging');
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var delta = e.pageX - startX;
      if (!hasDragged && Math.abs(delta) > DRAG_THRESHOLD) {
        hasDragged = true;
        el.classList.add('is-dragging');
      }
      if (hasDragged) {
        e.preventDefault();
        el.scrollLeft = startScrollLeft - delta;
      }
    });
  }

  function renderGallery(gallery, edition, variantId) {
    var slider = gallery.querySelector('[data-edition-slider]');
    var thumbs = gallery.querySelector('[data-edition-thumbs]');
    var items = readItems(edition, variantId);

    enableDragScroll(thumbs);

    if (flkty) { flkty.destroy(); flkty = null; }
    slider.innerHTML = items.map(slideMarkup).join('');
    thumbs.innerHTML = items.map(thumbMarkup).join('');

    if (window.Flickity && items.length > 1) {
      flkty = new Flickity(slider, {
        cellSelector: '.product-edition-gallery__slide',
        pageDots: false,
        prevNextButtons: true,
        wrapAround: true,
        autoPlay: false,
        resize: true,
        imagesLoaded: true,
        on: {
          select: function () {
            var index = this.selectedIndex;
            thumbs.querySelectorAll('img').forEach(function (t, i) {
              t.classList.toggle('is-selected', i === index);
            });
          }
        }
      });
    }

    thumbs.querySelectorAll('img').forEach(function (thumb, index) {
      thumb.classList.toggle('is-selected', index === 0);
      thumb.addEventListener('click', function () {
        if (flkty) flkty.select(index);
      });
    });
  }

  // Maps ?edition= URL values to the order tag that should end up on any
  // order placed from a cart carrying that edition. The theme can only set
  // this as a cart attribute (which rides through checkout onto the order's
  // "Additional details") - turning it into an actual order tag needs a
  // Shopify Flow: trigger "Order created" -> condition "note attributes
  // contains edition_tag: <value>" -> action "Add order tags: <value>".
  var EDITION_ORDER_TAGS = {
    new: 'Nexgenv2',
    pregnancy: 'Nexgenpregnancy'
  };

  function tagCartForEdition(edition) {
    var tagValue = EDITION_ORDER_TAGS[edition];
    if (!tagValue) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { edition_tag: tagValue } })
    }).catch(function () {});
  }

  function activateEditionGallery() {
    var params = new URLSearchParams(window.location.search);
    var edition = params.get('edition');
    tagCartForEdition(edition);

    var wrapper = document.querySelector('.product-edition-galleries');
    if (!wrapper) return;

    var gallery = edition && wrapper.querySelector('.product-edition-gallery[data-edition="' + edition + '"]');
    if (!gallery) return; // no edition param, or nothing uploaded for it -> leave default gallery as-is

    var defaultGallery = document.querySelector('.product-single__gallery');
    if (defaultGallery) defaultGallery.setAttribute('hidden', '');
    gallery.removeAttribute('hidden');

    var currentVariantId = wrapper.getAttribute('data-current-variant-id');
    renderGallery(gallery, edition, currentVariantId);

    document.addEventListener('theme:variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        renderGallery(gallery, edition, e.detail.variant.id);
      }
    });
  }

  function activateEditionDescription() {
    var params = new URLSearchParams(window.location.search);
    var edition = params.get('edition');
    if (edition !== 'pregnancy') return; // only Pregnancy has its own description right now

    var pregnancyDescription = document.querySelector('[data-edition-description="pregnancy"]');
    if (!pregnancyDescription) return; // nothing typed into the metafield -> leave default as-is

    var defaultDescription = document.querySelector('[data-edition-description="default"]');
    if (defaultDescription) defaultDescription.setAttribute('hidden', '');
    pregnancyDescription.removeAttribute('hidden');
  }

  function activateEditionShortDescription() {
    var params = new URLSearchParams(window.location.search);
    var edition = params.get('edition');
    if (edition !== 'pregnancy') return; // only Pregnancy has its own short description right now

    var valueHolder = document.querySelector('[data-edition-shortdesc-value]');
    if (!valueHolder) return; // nothing typed into the metafield -> leave default as-is

    document.querySelectorAll('[data-edition-shortdesc="default"]').forEach(function (el) {
      el.innerHTML = valueHolder.innerHTML;
    });
  }

  function activateEditionBadges() {
    var params = new URLSearchParams(window.location.search);
    var edition = params.get('edition');
    if (edition !== 'pregnancy') return; // only Pregnancy has its own badge text right now

    document.querySelectorAll('[data-edition-badge-value]').forEach(function (valueHolder) {
      var key = valueHolder.getAttribute('data-edition-badge-value');
      var target = document.querySelector('[data-edition-badge="' + key + '"]');
      if (target) target.innerHTML = valueHolder.innerHTML;
    });
  }

  function activateEditionTabs() {
    var params = new URLSearchParams(window.location.search);
    var edition = params.get('edition');
    if (edition !== 'pregnancy') return; // only Pregnancy has its own tab content right now

    document.querySelectorAll('[data-edition-tab-value]').forEach(function (valueHolder) {
      var key = valueHolder.getAttribute('data-edition-tab-value');
      var target = document.querySelector('[data-edition-tab="' + key + '"]');
      if (target) target.innerHTML = valueHolder.innerHTML;
    });
  }

  function activateEditionSimpleSection() {
    var params = new URLSearchParams(window.location.search);
    var edition = params.get('edition');
    if (edition !== 'new' && edition !== 'pregnancy') return; // original page keeps LeftTextRightImage as-is

    var simpleSection = document.querySelector('[data-edition-simple-section]');
    if (!simpleSection) return; // nothing filled into the metafields yet -> leave everything as-is

    // [data-edition-original] is LeftTextRightImage's own content wrapper
    // (sections/leftText-right-image-section.liquid) - only rendered by Shopify
    // when the section's own content metafield has something in it, so this
    // safely does nothing on products/pages that don't have that section.
    var originalContent = document.querySelector('[data-edition-original]');
    if (originalContent) originalContent.setAttribute('hidden', '');

    simpleSection.removeAttribute('hidden');
  }

  document.addEventListener('DOMContentLoaded', function () {
    activateEditionGallery();
    activateEditionDescription();
    activateEditionShortDescription();
    activateEditionBadges();
    activateEditionTabs();
    activateEditionSimpleSection();
  });
})();
